var _style, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "256px",
    height: "256px",
    viewBox: "0 0 600 450",
    style: {
      enableBackground: "new 0 0 600 450"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\tsvg{transform:scale(1.75);}\n\t.st0{fill:#FED955;}\n\t.st1{fill:#9090C7;}\n\t.st2{fill:#4956A2;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 203.2,
    y: 176.9,
    className: "st0",
    width: 24.2,
    height: 24.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 203.2,
    y: 225.4,
    className: "st0",
    width: 24.2,
    height: 24.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 203.2,
    y: 201.1,
    className: "st0",
    width: 24.2,
    height: 24.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 203.2,
    y: 249.6,
    className: "st0",
    width: 24.2,
    height: 24.2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 300.1,
    y: 128.5,
    className: "st0",
    width: 24.2,
    height: 24.2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 300.1,
    y: 298.1,
    className: "st0",
    width: 24.2,
    height: 24.2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 324.4,
    y: 128.5,
    className: "st0",
    width: 24.2,
    height: 24.2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 348.6,
    y: 128.5,
    className: "st1",
    width: 24.2,
    height: 24.2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 227.4,
    y: 128.5,
    className: "st1",
    width: 24.2,
    height: 24.2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 372.8,
    y: 273.8,
    className: "st1",
    width: 24.2,
    height: 24.2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 203.2,
    y: 273.8,
    className: "st1",
    width: 24.2,
    height: 24.2
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 324.4,
    y: 104.2,
    className: "st1",
    width: 24.2,
    height: 24.2
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 324.4,
    y: 80,
    className: "st2",
    width: 24.2,
    height: 24.2
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 324.4,
    y: 346.5,
    className: "st2",
    width: 24.2,
    height: 24.2
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 324.4,
    y: 322.3,
    className: "st1",
    width: 24.2,
    height: 24.2
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 275.9,
    y: 104.2,
    className: "st1",
    width: 24.2,
    height: 24.2
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 275.9,
    y: 80,
    className: "st2",
    width: 24.2,
    height: 24.2
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 275.9,
    y: 346.5,
    className: "st2",
    width: 24.2,
    height: 24.2
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 275.9,
    y: 322.3,
    className: "st1",
    width: 24.2,
    height: 24.2
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 300.1,
    y: 104.2,
    className: "st1",
    width: 24.2,
    height: 24.2
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 300.1,
    y: 80,
    className: "st2",
    width: 24.2,
    height: 24.2
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 300.1,
    y: 346.5,
    className: "st2",
    width: 24.2,
    height: 24.2
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 300.1,
    y: 322.3,
    className: "st1",
    width: 24.2,
    height: 24.2
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 251.7,
    y: 104.2,
    className: "st1",
    width: 24.2,
    height: 24.2
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 251.7,
    y: 80,
    className: "st2",
    width: 24.2,
    height: 24.2
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 251.7,
    y: 346.5,
    className: "st2",
    width: 24.2,
    height: 24.2
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 251.7,
    y: 322.3,
    className: "st1",
    width: 24.2,
    height: 24.2
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 372.8,
    y: 152.7,
    className: "st1",
    width: 24.2,
    height: 24.2
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 203.2,
    y: 152.7,
    className: "st1",
    width: 24.2,
    height: 24.2
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 348.6,
    y: 298.1,
    className: "st1",
    width: 24.2,
    height: 24.2
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 227.4,
    y: 298.1,
    className: "st1",
    width: 24.2,
    height: 24.2
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 397,
    y: 176.9,
    className: "st1",
    width: 24.2,
    height: 24.2
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 176.9,
    className: "st1",
    width: 24.2,
    height: 24.2
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 154.8,
    y: 176.9,
    className: "st2",
    width: 24.2,
    height: 24.2
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 152.7,
    className: "st2",
    width: 24.2,
    height: 24.2
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 397,
    y: 152.7,
    className: "st2",
    width: 24.2,
    height: 24.2
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 348.6,
    y: 322.3,
    className: "st2",
    width: 24.2,
    height: 24.2
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 273.8,
    className: "st2",
    width: 24.2,
    height: 24.2
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 203.2,
    y: 128.5,
    className: "st2",
    width: 24.2,
    height: 24.2
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 372.8,
    y: 128.5,
    className: "st2",
    width: 24.2,
    height: 24.2
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 372.8,
    y: 298.1,
    className: "st2",
    width: 24.2,
    height: 24.2
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 203.2,
    y: 298.1,
    className: "st2",
    width: 24.2,
    height: 24.2
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 227.4,
    y: 104.2,
    className: "st2",
    width: 24.2,
    height: 24.2
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 348.6,
    y: 104.2,
    className: "st2",
    width: 24.2,
    height: 24.2
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 397,
    y: 273.8,
    className: "st2",
    width: 24.2,
    height: 24.2
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 227.4,
    y: 322.3,
    className: "st2",
    width: 24.2,
    height: 24.2
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 421.3,
    y: 176.9,
    className: "st2",
    width: 24.2,
    height: 24.2
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 397,
    y: 201.1,
    className: "st1",
    width: 24.2,
    height: 24.2
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 201.1,
    className: "st1",
    width: 24.2,
    height: 24.2
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 154.8,
    y: 201.1,
    className: "st2",
    width: 24.2,
    height: 24.2
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 421.3,
    y: 201.1,
    className: "st2",
    width: 24.2,
    height: 24.2
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 397,
    y: 225.4,
    className: "st1",
    width: 24.2,
    height: 24.2
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 225.4,
    className: "st1",
    width: 24.2,
    height: 24.2
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 154.8,
    y: 225.4,
    className: "st2",
    width: 24.2,
    height: 24.2
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 421.3,
    y: 225.4,
    className: "st2",
    width: 24.2,
    height: 24.2
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 397,
    y: 249.6,
    className: "st1",
    width: 24.2,
    height: 24.2
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 249.6,
    className: "st1",
    width: 24.2,
    height: 24.2
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 154.8,
    y: 249.6,
    className: "st2",
    width: 24.2,
    height: 24.2
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 421.3,
    y: 249.6,
    className: "st2",
    width: 24.2,
    height: 24.2
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 324.4,
    y: 298.1,
    className: "st0",
    width: 24.2,
    height: 24.2
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 300.1,
    y: 176.9,
    className: "st0",
    width: 24.2,
    height: 24.2
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 300.1,
    y: 225.4,
    className: "st0",
    width: 24.2,
    height: 24.2
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 300.1,
    y: 249.6,
    className: "st0",
    width: 24.2,
    height: 24.2
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 300.1,
    y: 152.7,
    className: "st0",
    width: 24.2,
    height: 24.2
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 300.1,
    y: 273.8,
    className: "st0",
    width: 24.2,
    height: 24.2
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 251.7,
    y: 225.4,
    className: "st0",
    width: 24.2,
    height: 24.2
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 251.7,
    y: 201.1,
    className: "st0",
    width: 24.2,
    height: 24.2
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 251.7,
    y: 249.6,
    className: "st0",
    width: 24.2,
    height: 24.2
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 251.7,
    y: 152.7,
    className: "st0",
    width: 24.2,
    height: 24.2
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 251.7,
    y: 273.8,
    className: "st0",
    width: 24.2,
    height: 24.2
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 324.4,
    y: 225.4,
    className: "st0",
    width: 24.2,
    height: 24.2
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 324.4,
    y: 201.1,
    className: "st0",
    width: 24.2,
    height: 24.2
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 324.4,
    y: 249.6,
    className: "st0",
    width: 24.2,
    height: 24.2
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 324.4,
    y: 152.7,
    className: "st0",
    width: 24.2,
    height: 24.2
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 324.4,
    y: 273.8,
    className: "st0",
    width: 24.2,
    height: 24.2
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 275.9,
    y: 128.5,
    className: "st0",
    width: 24.2,
    height: 24.2
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 275.9,
    y: 298.1,
    className: "st0",
    width: 24.2,
    height: 24.2
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 251.7,
    y: 128.5,
    className: "st0",
    width: 24.2,
    height: 24.2
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 251.7,
    y: 298.1,
    className: "st0",
    width: 24.2,
    height: 24.2
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 275.9,
    y: 176.9,
    className: "st0",
    width: 24.2,
    height: 24.2
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 275.9,
    y: 225.4,
    className: "st0",
    width: 24.2,
    height: 24.2
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 251.7,
    y: 176.9,
    className: "st2",
    width: 24.2,
    height: 24.2
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 300.1,
    y: 201.1,
    className: "st2",
    width: 24.2,
    height: 24.2
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 348.6,
    y: 176.9,
    className: "st2",
    width: 24.2,
    height: 24.2
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 348.6,
    y: 225.4,
    className: "st2",
    width: 24.2,
    height: 24.2
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 348.6,
    y: 201.1,
    className: "st2",
    width: 24.2,
    height: 24.2
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 348.6,
    y: 249.6,
    className: "st2",
    width: 24.2,
    height: 24.2
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 348.6,
    y: 152.7,
    className: "st2",
    width: 24.2,
    height: 24.2
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 348.6,
    y: 273.8,
    className: "st2",
    width: 24.2,
    height: 24.2
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 227.4,
    y: 176.9,
    className: "st2",
    width: 24.2,
    height: 24.2
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 227.4,
    y: 225.4,
    className: "st2",
    width: 24.2,
    height: 24.2
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 227.4,
    y: 201.1,
    className: "st2",
    width: 24.2,
    height: 24.2
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 227.4,
    y: 249.6,
    className: "st2",
    width: 24.2,
    height: 24.2
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 227.4,
    y: 152.7,
    className: "st2",
    width: 24.2,
    height: 24.2
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 227.4,
    y: 273.8,
    className: "st2",
    width: 24.2,
    height: 24.2
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 324.4,
    y: 176.9,
    className: "st2",
    width: 24.2,
    height: 24.2
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 275.9,
    y: 201.1,
    className: "st2",
    width: 24.2,
    height: 24.2
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 275.9,
    y: 249.6,
    className: "st0",
    width: 24.2,
    height: 24.2
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 275.9,
    y: 152.7,
    className: "st0",
    width: 24.2,
    height: 24.2
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 275.9,
    y: 273.8,
    className: "st0",
    width: 24.2,
    height: 24.2
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 372.8,
    y: 176.9,
    className: "st0",
    width: 24.2,
    height: 24.2
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 372.8,
    y: 225.4,
    className: "st0",
    width: 24.2,
    height: 24.2
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 372.8,
    y: 201.1,
    className: "st0",
    width: 24.2,
    height: 24.2
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 372.8,
    y: 249.6,
    className: "st0",
    width: 24.2,
    height: 24.2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMim);
export default __webpack_public_path__ + "static/media/mim.f210cbc592091fa0e837012dcfd29d0f.svg";
export { ForwardRef as ReactComponent };